<template>
    <BCol cols="12" :md="vsMd">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="vsRules">
            <BFormGroup :label="$t(vsName)" :label-for="vsName.toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                <BFormTextarea :id="vsName.toLowerCase()" :value="vsModel" @input="$emit('update:vsModel', $event)" />
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol> 
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { BCol, BFormGroup, BFormTextarea, BFormInvalidFeedback } from 'bootstrap-vue';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormTextarea, BFormInvalidFeedback },
    props: ['vsName', 'vsModel', 'vsRules', 'vsRequired', 'vsMd'],
    emit: ['update:vsModel'],
    setup() {
        const { getValidationState } = formValidation()

        return {
            getValidationState
        }
    },
}
</script>

<style>

</style>